var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orders-list" },
    [
      _c("h2", [_vm._v("Orders")]),
      _c("div", { staticStyle: { "margin-bottom": "20px", display: "flex" } }, [
        _c(
          "div",
          {
            staticClass: "control has-icons-left",
            staticStyle: { flex: "1", "margin-right": "20px" }
          },
          [
            _vm._m(0),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.orderSearch,
                  expression: "orderSearch"
                }
              ],
              staticClass: "input has-icons-left",
              attrs: { type: "text", placeholder: "Search by name or email" },
              domProps: { value: _vm.orderSearch },
              on: {
                keyup: _vm.searchOrders,
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.orderSearch = $event.target.value
                }
              }
            })
          ]
        ),
        _c("div", [
          _c(
            "button",
            { staticClass: "button", on: { click: _vm.exportCsv } },
            [_vm._v("Export CSV")]
          )
        ])
      ]),
      _c("table", { staticClass: "table is-fullwidth orders-table" }, [
        _vm._m(1),
        _c(
          "tbody",
          _vm._l(_vm.visibleOrders, function(order) {
            return _c(
              "tr",
              {
                key: order.id,
                staticClass: "clickable-row",
                on: {
                  click: function($event) {
                    return _vm.showOrderDetails(order)
                  }
                }
              },
              [
                _c("td", { staticClass: "date-cell" }, [
                  _c("span", { staticClass: "is-hidden-mobile" }, [
                    _vm._v(
                      _vm._s(
                        order.created
                          ? _vm
                              .moment(order.created.toDate())
                              .format("M/D/YY LT")
                          : ""
                      )
                    )
                  ]),
                  _c("span", { staticClass: "is-hidden-tablet" }, [
                    _c("span", { staticClass: "date-part" }, [
                      _vm._v(
                        _vm._s(
                          order.created
                            ? _vm.moment(order.created.toDate()).format("M/D")
                            : ""
                        )
                      )
                    ]),
                    _c("span", { staticClass: "time-part" }, [
                      _vm._v(
                        _vm._s(
                          order.created
                            ? _vm.moment(order.created.toDate()).format("LT")
                            : ""
                        )
                      )
                    ])
                  ])
                ]),
                _c("td", { staticClass: "name-cell" }, [
                  _c("span", { staticClass: "name-part" }, [
                    _vm._v(
                      _vm._s(order.firstName) + " " + _vm._s(order.lastName)
                    )
                  ]),
                  _c("span", { staticClass: "email-part is-hidden-tablet" }, [
                    _vm._v(_vm._s(order.email))
                  ])
                ]),
                _c("td", { staticClass: "is-hidden-mobile" }, [
                  _vm._v(_vm._s(order.email))
                ]),
                _c("td", { staticClass: "is-hidden-mobile" }, [
                  _vm._v(_vm._s(order.discountCode))
                ]),
                _c("td", { staticClass: "qty-col" }, [
                  _vm._v(_vm._s(order.quantity))
                ]),
                _c("td", { staticClass: "is-hidden-mobile" }, [
                  _vm._v(_vm._s(order.donation))
                ]),
                _c("td", [_vm._v("$" + _vm._s(order.total.toFixed(2)))])
              ]
            )
          }),
          0
        )
      ]),
      _c("Paginator", {
        attrs: {
          pageSize: 10,
          itemCount:
            _vm.filteredOrders.length > 0
              ? _vm.filteredOrders.length
              : _vm.orders.length
        },
        on: { pageChanged: _vm.setOrdersPage }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small is-right" }, [
      _c("i", { staticClass: "fas fa-search" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [
          _c("span", { staticClass: "is-hidden-mobile" }, [
            _vm._v("Order Created")
          ]),
          _c("span", { staticClass: "is-hidden-tablet" }, [_vm._v("Created")])
        ]),
        _c("th", [_vm._v("Name")]),
        _c("th", { staticClass: "is-hidden-mobile" }, [_vm._v("Email")]),
        _c("th", { staticClass: "is-hidden-mobile" }, [
          _vm._v("Discount Code")
        ]),
        _c("th", { staticClass: "qty-col" }, [_vm._v("Qty")]),
        _c("th", { staticClass: "is-hidden-mobile" }, [_vm._v("Donation")]),
        _c("th", [_vm._v("Total")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }